import AsyncStorage from '@react-native-community/async-storage';
import { persistReducer } from 'redux-persist';

import reducer from './reducer';

export default persistReducer(
  {
    key: 'authentication',
    blacklist: ['refreshing', 'labels'],
    storage: AsyncStorage,
  },
  reducer
);
